module.exports = __webpack_public_path__ + "assets/img/21_58_big.907df3af.jpg";